import { useState } from 'react';
import { faqItems } from '@/mocks/home';

export default function FAQSection() {
  const [openId, setOpenId] = useState<string | null>(null);

  const toggleFAQ = (id: string) => {
    setOpenId(openId === id ? null : id);
  };

  return (
    <section className="py-20 md:py-28 bg-background-50">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12 md:mb-16">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold mb-4">
            常见问题
          </span>
          <h2 className="font-heading font-bold text-3xl md:text-4xl text-foreground-950 mb-3">
            世界杯观赛 · 高频问答
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            关于2026世界杯，您想了解的一切都在这里
          </p>
        </div>

        <div className="max-w-3xl mx-auto flex flex-col gap-3">
          {faqItems.map((item) => {
            const isOpen = openId === item.id;
            return (
              <div
                key={item.id}
                className="bg-background-50 rounded-xl border border-background-200/70 overflow-hidden transition-all duration-200"
              >
                <button
                  type="button"
                  onClick={() => toggleFAQ(item.id)}
                  className="w-full flex items-center justify-between p-5 text-left cursor-pointer"
                >
                  <span className="font-heading font-semibold text-sm md:text-base text-foreground-900 pr-4">
                    {item.question}
                  </span>
                  <span
                    className={`w-6 h-6 flex items-center justify-center shrink-0 rounded-full transition-all duration-300 ${
                      isOpen
                        ? 'bg-primary-500 text-background-50 rotate-45'
                        : 'bg-background-200 text-foreground-500'
                    }`}
                  >
                    <i className="ri-add-line text-sm"></i>
                  </span>
                </button>
                <div
                  className={`transition-all duration-300 overflow-hidden ${
                    isOpen ? 'max-h-96 pb-5 px-5' : 'max-h-0'
                  }`}
                >
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {item.answer}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}